import { z } from 'zod'
import { api } from '@/lib/api'

export const faxRecipientSchema = z.object({
  name: z.string().default(''),
  fax_number: z.string(),
})

export const scheduleSchema = z.object({
  id: z.string(),
  facility_id: z.string(),
  cadence: z.enum(['daily', 'weekly', 'biweekly', 'monthly']),
  days_of_week: z.array(z.string()),
  day_of_month: z.number().nullable(),
  send_hour_local: z.number(),
  send_minute_local: z.number(),
  timezone: z.string(),
  lookback_days: z.number(),
  active: z.boolean(),
  recipients: z.array(faxRecipientSchema),
})

export type Schedule = z.infer<typeof scheduleSchema>
export type FaxRecipient = z.infer<typeof faxRecipientSchema>

export interface ScheduleUpsertInput {
  cadence: 'daily' | 'weekly' | 'biweekly' | 'monthly'
  days_of_week: string[]
  day_of_month?: number | null
  send_hour_local: number
  send_minute_local: number
  timezone: string
  lookback_days: number
  active: boolean
  recipients: FaxRecipient[]
}

export async function getFacilitySchedule(facilityId?: string | null): Promise<Schedule | null> {
  try {
    const data = await api.get<unknown>('/schedules/facility', {
      params: facilityId ? { facility_id: facilityId } : undefined,
    })
    return scheduleSchema.parse(data)
  } catch {
    return null
  }
}

export async function upsertFacilitySchedule(
  input: ScheduleUpsertInput,
  facilityId?: string | null,
): Promise<Schedule> {
  const body: Record<string, unknown> = { ...input }
  if (facilityId) body.facility_id = facilityId
  const data = await api.put<unknown>('/schedules/facility', body)
  return scheduleSchema.parse(data)
}

export async function fireScheduleNow(facilityId?: string | null): Promise<void> {
  await api.post<unknown>('/schedules/facility/fire', {}, {
    params: facilityId ? { facility_id: facilityId } : undefined,
  })
}
